export function canSubmitHoldRemoval(state, reasonRequired) {
  return Boolean(
    (!reasonRequired || (state.reason && state.reason.length > 0)) &&
      (!state.followUp || state.followUpAt) &&
      (state.reason !== "Other" || (state.explanation && state.explanation.length > 0))
  );
}

export function canSubmitHoldConfirm(state) {
  return Boolean(
    state.start_time &&
      state.door_time &&
      state.end_time &&
      state.selectedHoldPositionId &&
      state.roomIds &&
      state.roomIds.length > 0
  );
}
